<template>
  <div class="dataCenter">
    <div class="content_appeal">
      <div class="title">内容吸引力</div>
      <div class="content_data">
        <div class="list_item" v-for="item in contentData" :key="item.id">
          <div class="name">
            {{ item.name }}
          </div>
          <div class="value">{{ video_id==1?item.value1:item.value2 }}</div>
        </div>
      </div>
      <!-- <div class="button_box">
        <div class="right_title">观看趋势</div>
        <div class="left_button">
          <span :class="[{'active_span':activeTypeId==1}]">留存</span>
          <span :class="[{'active_span':activeTypeId==2}]">跳出</span>
        </div>
      </div> -->
    </div>
    <div class="content_appeal">
      <div class="title">观众参与度</div>
      <div class="content_data">
        <div class="list_item" v-for="item in peopleData" :key="item.id">
          <div class="name">
            {{ item.name }}
          </div>
          <div class="value">{{ video_id==1?item.value1:item.value2}}</div>
        </div>
      </div>
    </div>
    <div class="content_appeal">
      <div class="title">流量来源</div>
      <div class="table_header" style="color: #999;">
        <div class="name">渠道来源</div>
        <div class="proportion">来源占比</div>
        <div class="compare">对比7日</div>
      </div>
      <div class="table_header" v-for="item in flowFromData" :key="item.name">
        <div class="name">{{ item.name }}</div>
        <div class="proportion"><el-progress :percentage="video_id==1?item.proportion1:item.proportion2" color="#577cf7"></el-progress>
        </div>
        <div class="compare" :style="{color:item.Compare1<0?'#73c97f':'#ea4b35'}">{{video_id==1? item.Compare1:item.Compare2 }}%</div>
      </div>
      <div class="title" style="margin-top: 20px;">额外流量</div>
      <div class="flow_show"><span>搜索额外流量</span><span style="color: #73747a;">{{ video_id==1?5202:2076}}次播放</span></div>
      <div class="title" style="margin-top: 20px;">搜索关键词</div>
      <div class="show_tip">作品和用户搜索的关键词相关，或能激发用户看完作品后搜索更多关键词，更容易获得「搜索额外流量」</div>
      <div class="swiper" v-draggle-scroll-x @draggle-scroll-x="handleScroll">
        <div class="item">
          <div class="title">用户通过这些词看到作品</div>
          <div class="show_data" v-for="(item , index) in keyWordsData[video_id-1].viewKey" :key="item.name">
            <div class="name_box"><span class="name" :style="{ color:index==0?'#e94359':index==1?'#e1ac47':index==2?'#e3b152':'#43454c'}">{{index+1}}</span><span>{{ item.name }}</span></div>
            <div style="color: #b3b4b7;">{{ item.value }}%</div>
          </div>
        </div>
        <div class="item">
          <div class="title">用户看完作品后常搜的词</div>
          <div class="show_data" v-for="(item , index) in keyWordsData[video_id-1].searchKey" :key="item.name">
            <div class="name_box"><span class="name" :style="{ color:index==0?'#e94359':index==1?'#e1ac47':index==2?'#e3b152':'#43454c'}">{{index+1}}</span><span>{{ item.name }}</span></div>
            <div style="color: #b3b4b7;">{{ item.value }}%</div>
          </div>
        </div>

      </div>
      <div class="indicate">
        <div class="indicate_box"><span :class="activeKeyId==1?'item':''"></span><span :class="activeKeyId==2?'item':''"></span></div>
      </div>
    </div>

  </div>
</template>
    
    <script>
import { draggleScrollX } from "../../utils/directives.js";
export default {
  data() {
    return {
      contentData: [
        {
          name: "完播率",
          id: 1,
          value1: "22.09%",
          value2: "11.86%",
          unit: "%",
        },
        {
          name: "平均播放时长",
          id: 2,
          value1: "9秒",
          value2: "12秒",
          unit: "",
        },
        {
          name: "2s跳出率",
          id: 3,
          value1: "36.49%",
          value2: "35.94%",
          unit: "%",
        },
        {
          name: "5s完播率",
          id: 4,
          value1: "40.11%",
          value2: "43.56%",
          unit: "%",
        },
        {
          name: "平均播放占比",
          id: 5,
          value1: "40.41%",
          value2: "26.75%",
          unit: "%",
        },
      ],
      peopleData: [
        {
          name: "点赞率",
          id: 1,
          value1: "0.13%",
          value2: "0.55%",
          unit: "%",
        },
        {
          name: "评论率",
          id: 2,
          value1: "0.01%",
          value2: "0.01%",
          unit: "%",
        },
        {
          name: "分享率",
          id: 3,
          value1: "0.06%",
          value2: "0.27%",
          unit: "%",
        },
        {
          name: "收藏率",
          id: 4,
          value1: "0.02%",
          value2: "0.05%",
          unit: "%",
        },
        {
          name: "弹幕量",
          id: 5,
          value1: "0",
          value2: "0",
          unit: "",
        },
        {
          name: "不感兴趣率",
          id: 6,
          value1: "0.06%",
          value2: "0.24%",
          unit: "%",
        },
      ],
      flowFromData: [
        {
          name: "推荐页",
          proportion1: 99.7,
          Compare1: 4.9,
          proportion2: 97.8,
          Compare2: 3,
        },
        {
          name: "个人主页",
          proportion1: 0.1,
          Compare1: -0.2,
          proportion2: 0.9,
          Compare2: 0.1,
        },
        {
          name: "其他",
          proportion1: 0.1,
          Compare1: -0.3,
          proportion2: 0.7,
          Compare2: 0.2,
        },
        {
          name: "关注页",
          proportion1: 0.1,
          Compare1: -0.2,
          proportion2: 0.4,
          Compare2: 0.2,
        },
        {
          name: "综搜页",
          proportion1: 0,
          Compare1: -2,
          proportion2: 0.1,
          Compare2: -1.9,
        },
      ],
      activeTypeId: 1,
      video_id: this.$route.query.video_id,
      keyWordsData: [
        {
          id: 1,
          viewKey: [
            {
              name: "彩椒",
              value: 97.6,
            },
            {
              name: "甜不辣辣子",
              value: 2.4,
            },
          ],
          searchKey: [
            {
              name: "彩椒水果",
              value: 47.4,
            },
            {
              name: "彩椒",
              value: 27.4,
            },
            {
              name: "水果彩椒",
              value: 8.7,
            },
            {
              name: "ally",
              value: 4.8,
            },
            {
              name: "ally路人视角",
              value: 4.1,
            },
            {
              name: "彩椒生吃的功效与作用",
              value: 3.4,
            },
          ],
        },
        {
          id: 2,
          viewKey: [
            {
              name: "ally",
              value: 29.8,
            },
            {
              name: "韩奎真ally",
              value: 21.6,
            },
            {
              name: "ally路人视角",
              value: 8.1,
            },
            {
              name: "ally男朋友",
              value: 8.1,
            },
            {
              name: "ally账号",
              value: 5.4,
            },
            {
              name: "被揪住了",
              value: 5.4,
            },
          ],
          searchKey: [
            {
              name: "韩奎真ally",
              value: 41.2,
            },
            {
              name: "ally",
              value: 34.9,
            },
            {
              name: "ally素颜照",
              value: 15.7,
            },
            {
              name: "ally抖音号",
              value: 5.4,
            },
            {
              name: "ally账号",
              value: 2.8,
            },
          ],
        },
      ],
      activeKeyId: 1,
    };
  },
  directives: {
    draggleScrollX: draggleScrollX,
  },
  mounted() {},

  methods: {
    handleScroll(event) {
      const scrollLeft = event.detail.scrollLeft;
      if (scrollLeft > 200) {
        this.activeKeyId = 2;
      }
      if (scrollLeft < 40) {
        this.activeKeyId = 1;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.dataCenter {
  width: 100%;
  .content_appeal {
    width: 100%;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 4px;
    margin-top: 15px;
    &:nth-of-type(1) {
      margin-top: 0;
    }

    .title {
      font-weight: 700;
      font-size: 16px;
    }
    .content_data {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;

      .list_item {
        width: 33%;
        padding: 8px;
        padding-bottom: 10px;
        padding-right: 5px;
        box-sizing: border-box;
        cursor: pointer;
        .name {
          font-size: 14px;
          color: #999;
        }
        .value {
          margin-top: 5px;
          font-weight: 600;
          font-size: 15px;
        }
        &:nth-of-type(1) {
          border-right: 1px solid #f5f5f6;
        }
        &:nth-of-type(2) {
          border-right: 1px solid #f5f5f6;
        }
        &:nth-of-type(4) {
          border-right: 1px solid #f5f5f6;
        }
        &:nth-of-type(5) {
          border-right: 1px solid #f5f5f6;
        }
      }
    }
    .button_box {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_button {
        span {
          background: #f3f3f3;
          padding: 3px 6px;
          margin-right: 5px;
          border-radius: 4px;
          color: #999;
          cursor: pointer;
        }
        .active_span {
          color: #333;
        }
      }
      .right_title {
        font-size: 15px;
        font-weight: 600;
      }
    }
    .table_header {
      display: flex;
      margin-top: 10px;

      .name {
        width: 25%;
      }
      .proportion {
        width: 55%;
      }
      .compare {
        width: 20%;
        text-align: right;
        padding-right: 4px;
        box-sizing: border-box;
      }
    }
    .flow_show {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
    .show_tip {
      background: #f7f7f8;
      padding: 6px;
      border-radius: 4px;
      margin-top: 10px;
      color: #73747a;
    }
    .swiper {
      margin-top: 10px;
      width: 100%;
      display: flex;
      overflow-x: auto;
      padding: 10px 0;
      .item {
        flex-shrink: 0;
        width: 250px;
        height: 200px;
        &:nth-of-type(1) {
          border-right: 1px solid #f4f4f4;
        }
        .title {
          color: #b3b4b7;
          font-size: 13px;
          margin-bottom: 10px;
        }
        .show_data {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5px;
          padding-right: 10px;
          .name_box {
            .name {
              font-weight: 600;
              margin-right: 5px;
            }
          }
        }
        &:nth-of-type(2) {
          border-right: 1px solid #f4f4f4;
          padding-left: 10px;
        }
      }
    }
    .indicate {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .indicate_box {
        width: 26px;
        height: 2px;
        background: #e5e5e5;
        display: flex;
        border-radius: 4px;
        span {
          width: 13px;
          height: 2px;
          border-radius: 4px;
        }
        .item {
          background: #686868;
        }
      }
    }
  }
}
::v-deep .el-progress-bar__outer {
  height: 10px !important;
  border-radius: 2px !important;
}
::v-deep .el-progress-bar__inner {
  border-radius: 2px !important;
}
</style>
    